/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonthStat
 */
export interface MonthStat {
    /**
     * 月份（1-12）
     * @type {number}
     * @memberof MonthStat
     */
    month?: number;
    /**
     * 订单数量
     * @type {number}
     * @memberof MonthStat
     */
    count?: number;
}

/**
 * Check if a given object implements the MonthStat interface.
 */
export function instanceOfMonthStat(value: object): value is MonthStat {
    return true;
}

export function MonthStatFromJSON(json: any): MonthStat {
    return MonthStatFromJSONTyped(json, false);
}

export function MonthStatFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonthStat {
    if (json == null) {
        return json;
    }
    return {
        
        'month': json['month'] == null ? undefined : json['month'],
        'count': json['count'] == null ? undefined : json['count'],
    };
}

export function MonthStatToJSON(json: any): MonthStat {
    return MonthStatToJSONTyped(json, false);
}

export function MonthStatToJSONTyped(value?: MonthStat | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'month': value['month'],
        'count': value['count'],
    };
}

